import { makeAutoObservable } from 'mobx';
import { logger } from '@/utils/logger';

/**
 * Iframe状态管理器
 * 负责管理iframe的状态信息
 */
export class IframeStateManager {
  // 状态属性
  isInitialized = false;
  isIframeReady = false;
  isSwitchingConversation = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  // 设置初始化状态
  setInitialized = value => {
    this.isInitialized = value;
    logger.debug('[IframeStateManager] 设置初始化状态:', value);
  };

  // 设置iframe就绪状态
  setIframeReady = value => {
    this.isIframeReady = value;
    logger.debug('[IframeStateManager] 设置iframe就绪状态:', value);
  };

  // 设置切换会话状态
  setSwitchingConversation = value => {
    this.isSwitchingConversation = value;
    logger.debug('[IframeStateManager] 设置切换会话状态:', value);
  };

  // 设置错误状态
  setError = error => {
    this.error = error;
    if (error) {
      logger.error('[IframeStateManager] 设置错误状态:', error);
    } else {
      logger.debug('[IframeStateManager] 清除错误状态');
    }
  };

  // 重置所有状态
  reset = () => {
    this.isInitialized = false;
    this.isIframeReady = false;
    this.isSwitchingConversation = false;
    this.error = null;
    logger.debug('[IframeStateManager] 重置所有状态');
  };
}
